import { Link } from 'react-router-dom';
import styles from '../styles/Breadcrumb.module.css';

const Breadcrumb = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <nav className={styles.wrapper} aria-label="Breadcrumb">
    <div className={styles.inner}>
        <ol className={styles.breadcrumb}>
        {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
            <li key={index} className={styles.item}>
                {item.link && !isLast ? (
                <Link to={item.link} className={styles.link}>
                    {item.label}
                </Link>
                ) : (
                <span className={styles.current}>{item.label}</span>
                )}

                {!isLast && (
                <span className={styles.separator}>›</span>
                )}
            </li>
            );
        })}
        </ol>
    </div>
    </nav>
  );
};

export default Breadcrumb;